module.exports = __webpack_public_path__ + "static/media/Grasshopper.19cb82ca.png";